import { CustomFieldParentTypes } from '@shared/utils/constants';
import { asyncForEach } from '@shared/utils/array';
import {
	getCustomFields,
	createCustomField,
	updateCustomField,
} from '@client/lib/api';

export const generateVoyageCustomFields = async (params: {
	orgId: number;
	voyageId: number;
}) => {
	const { orgId, voyageId } = params;

	if (!orgId) {
		return;
	}

	// Fetch both template and voyage-specific custom fields
	const [templateFields, voyageFields] = await Promise.all([
		getCustomFields({
			parentId: orgId,
			parentType: CustomFieldParentTypes.ORG,
		}),
		getCustomFields({
			parentId: orgId,
			parentType: CustomFieldParentTypes.ORG,
			voyageId,
		}),
	]);

	await asyncForEach(templateFields, async (t) => {
		const existing = voyageFields.find((vf) => vf.customFieldId === t.id);

		if (!existing) {
			// If no existing voyage custom field, create one based on the template
			await createCustomField({
				type: t.type,
				label: t.label,
				value: '',
				voyageId,
				parentType: t.parentType,
				parentId: t.parentId,
				customFieldId: t.id,
			});
		} else if (existing.label !== t.label || existing.type !== t.type) {
			// If the label or type has changed, update the existing voyage custom field
			await updateCustomField({
				id: existing.id,
				label: t.label,
				type: t.type,
				value: existing.value,
			});
		}
	});
};
